<template>
  <div style="display: inline-block;">
    <auth-button opt="batch_import" :label="buttonText" icon="el-icon-upload2" @click.native="multiInvoiceEntry"></auth-button>
    <el-dialog
      v-if="multiDialogVisible"
      :visible.sync="multiDialogVisible"
      title="批量导入"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true">
      <p class="tips" v-html="tipsText"></p>
      <el-button size="small" type="primary" @click="download()" v-if="templateType === 'http'">下载模板文件</el-button>
      <a :href="templateUrl" :download="templateName" v-else><el-button size="small" type="primary">下载模板文件</el-button></a>
      <input type="file" id="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      <el-button type="primary" plain size="small" class="check" @click="getMultiFiles()">批量导入</el-button>
      <p>仅支持.xls、.xlsx格式</p>
      <el-col v-if="multiFileName !== ''" class="hasSelect">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
      <div slot="footer">
        <el-button type="primary" size="small" @click="multiInvoice" :loading="buttonLoading">确认</el-button>
        <el-button size="small" @click="multiDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量导入完成" :visible.sync="importDialogVisible" center width="500px" :append-to-body="true">
      <p class="marginBtm">成功{{ this.successNum }}条，失败{{ this.failNum }}条</p>
      <el-table border size="small" :data="failData">
        <el-table-column prop="line" label="行数" width="70" align="center"></el-table-column>
        <el-table-column v-if="failedIdName !== ''" :prop="failedIdName" :label="failedIdText" width="120" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="70" align="center"></el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<!--    目前仅支持上传表格-->
<script>
// import qs from 'qs'
import importFn from '@/api/importFn'
import api from '@/api/index'
// 导出的接口名称都需在改文件中定义，因为无法引入动态的方法名
export default {
  name: 'BatchImport',
  props: {
    // 模板下载url
    templateUrl: {
      type: String,
      default: ''
    },
    // 模板方式，取值有http请求，local本地
    templateType: {
      type: String,
      default: 'http'
    },
    // 导入按钮文本
    buttonText: {
      type: String,
      default: '批量导入'
    },
    // 提交接口
    submitName: {
      type: String,
      default: 'batchInputInvoice'
    },
    // 上传失败的数据Id属性名
    failedIdName: {
      type: String,
      default: ''
    },
    // 上传失败的数据Id属性文本
    failedIdText: {
      type: String,
      default: ''
    },
    tipsText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      multiFile: '', // 批量上传的文件
      buttonLoading: false, // 提交按钮加载
      multiDialogVisible: false, // 导入弹窗
      successNum: 0, // 成功条数
      failNum: 0, // 失败条数
      failData: [], // 失败详细信息
      importDialogVisible: false, // 批量导入结果
      multiFileName: '', // 批量文件名
      templateName: ''// 模板下载文件名称
    }
  },
  mounted () {
    if (this.templateType === 'local') { this.templateName = this.templateUrl.replace('./static/', '') }
  },
  methods: {
    /**
             * @description 批量录入发票
             */
    multiInvoiceEntry () {
      this.buttonLoading = false
      this.multiDialogVisible = true
      this.multiFile = ''
      this.multiFileName = ''
    },
    /**
             * @description 上传文件
             */
    getMultiFiles () {
      this.$jquery('#file').click()
    },
    /**
             * @description 删除已上传文件
             */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
             * @description 选择文件
             */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    /**
             * @description 批量导入提交
             */
    multiInvoice () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      this.buttonLoading = true
      const data = new FormData()
      data.append('multipartFile', this.multiFile)
      importFn[this.submitName](data).then((data) => {
        this.buttonLoading = false
        if (parseInt(data.error_code) !== 0 && parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg || data.result_msg,
            type: 'error'
          })
        } else {
          this.successNum = data.success_num
          if (data.fail_num === 0) {
            this.$message({
              showClose: true,
              message: data.error_msg + '，成功导入' + data.success_num + '条',
              type: 'success'
            })
          } else {
            this.importDialogVisible = true
            this.failNum = data.fail_num
            this.failData = data.result
          }
          this.multiDialogVisible = false
          this.$emit('submit', true)
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
        this.$emit('submit', false)
      })
    },
    /**
             * @description 批量模板下载
             */
    download () {
      var p = api.host
      window.location.href = p + this.templateUrl
    }
  }
}
</script>

<style scoped>
    .hasSelect{
        font-size: 15px;
        margin-top: 20px;
    }
    .hasSelect span{
        float: left;
        margin-bottom: 20px;
        line-height: 30px;
        display: inline-block;
        max-width: 430px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .hasSelect .removeIcon{
        color:#F56C6C;
        line-height: 30px;
        cursor: pointer;
        margin-left: 10px;
    }
    .tips{
        margin: 0;
        margin-bottom: 20px;
        font-size: 14px;
        color: #acacac;
        line-height: 20px;
    }
    .check {
        margin-left:5px
    }
</style>
